import { fileBody, restPost, restPut } from "apiCommandsExecutor/rest";

import { MediaItemDto } from "services/menu/restModels";

import { MenuItemRendition, UploadedImageDto } from "./restModels";

/*
* Медиа позиции меню: тип файла бэк определяет сам и отдаёт готовую медиа-запись.
* Картинку он режет на card и detail, gif и видео забирает как есть — у них рендиций нет.
* */
export const uploadMenuItemMedia = (file: File) =>
    restPost<MediaItemDto>("/uploads/menu-item-media", fileBody(file));

// Перекадрирование уже загруженной картинки: кроп заменяет рендицию по тому же адресу.
export const replaceMenuItemRendition = (
    sourceId: string,
    rendition: MenuItemRendition,
    file: File
) =>
    restPut<UploadedImageDto>(
        `/uploads/menu-item-media/${sourceId}/${rendition}`,
        fileBody(file)
    );

export const uploadMenuCover = (file: File) =>
    restPost<UploadedImageDto>("/uploads/images/menu-cover", fileBody(file));

export const uploadMenuLogo = (file: File) =>
    restPost<UploadedImageDto>("/uploads/images/menu-logo", fileBody(file));

export const uploadInfoMessageImage = (file: File) =>
    restPost<UploadedImageDto>("/uploads/images/info-message", fileBody(file));

export const uploadSupplierLogo = (file: File) =>
    restPost<UploadedImageDto>("/uploads/images/supplier-logo", fileBody(file));
